/* eslint-disable camelcase */

/**
 * NOTE: This is an auto-generated file
 */

import Accessibility from './assets/customer/default/Accessibility.svg';
import ActionPlan from './assets/customer/default/ActionPlan.svg';
import AddUser from './assets/customer/default/AddUser.svg';
import Agenda from './assets/customer/default/Agenda.svg';
import AgendaFocused from './assets/customer/default/AgendaFocused.svg';
import Ages from './assets/customer/default/Ages.svg';
import AirPlay from './assets/customer/default/AirPlay.svg';
import AirPlayOff from './assets/customer/default/AirPlayOff.svg';
import AirPlayOn from './assets/customer/default/AirPlayOn.svg';
import Alert from './assets/customer/default/Alert.svg';
import AlertOff from './assets/customer/default/AlertOff.svg';
import AlertOn from './assets/customer/default/AlertOn.svg';
import AlertUnread from './assets/customer/default/AlertUnread.svg';
import Android from './assets/customer/default/Android.svg';
import Apple from './assets/customer/default/Apple.svg';
import Approved from './assets/customer/default/Approved.svg';
import ArrowDown from './assets/customer/default/ArrowDown.svg';
import ArrowLeft from './assets/customer/default/ArrowLeft.svg';
import ArrowLeftWithBase from './assets/customer/default/ArrowLeftWithBase.svg';
import ArrowRight from './assets/customer/default/ArrowRight.svg';
import ArrowRightWithBase from './assets/customer/default/ArrowRightWithBase.svg';
import ArrowSideNav from './assets/customer/default/ArrowSideNav.svg';
import ArrowUp from './assets/customer/default/ArrowUp.svg';
import Article from './assets/customer/default/Article.svg';
import Audio from './assets/customer/default/Audio.svg';
import AudioDescriptionTag from './assets/customer/default/AudioDescriptionTag.svg';
import Audiobook from './assets/customer/default/Audiobook.svg';
import BackSpace from './assets/customer/default/BackSpace.svg';
import BackToLive from './assets/customer/default/BackToLive.svg';
import BankCard from './assets/customer/default/BankCard.svg';
import Brightness from './assets/customer/default/Brightness.svg';
import Brightness1 from './assets/customer/default/Brightness1.svg';
import Brightness2 from './assets/customer/default/Brightness2.svg';
import Brightness3 from './assets/customer/default/Brightness3.svg';
import Brightness4 from './assets/customer/default/Brightness4.svg';
import BrightnessFilled from './assets/customer/default/BrightnessFilled.svg';
import Buffering from './assets/customer/default/Buffering.svg';
import Cancel from './assets/customer/default/Cancel.svg';
import CapsLock from './assets/customer/default/CapsLock.svg';
import Category from './assets/customer/default/Category.svg';
import CategoryFocused from './assets/customer/default/CategoryFocused.svg';
import Chapter from './assets/customer/default/Chapter.svg';
import Check from './assets/customer/default/Check.svg';
import CheckFocused from './assets/customer/default/CheckFocused.svg';
import CheckLight from './assets/customer/default/CheckLight.svg';
import Chromecast from './assets/customer/default/Chromecast.svg';
import ChromecastOff from './assets/customer/default/ChromecastOff.svg';
import ChromecastOff1 from './assets/customer/default/ChromecastOff1.svg';
import ChromecastOff2 from './assets/customer/default/ChromecastOff2.svg';
import ChromecastOn from './assets/customer/default/ChromecastOn.svg';
import ChromecastOn1 from './assets/customer/default/ChromecastOn1.svg';
import ChromecastOn2 from './assets/customer/default/ChromecastOn2.svg';
import Clock from './assets/customer/default/Clock.svg';
import Connected from './assets/customer/default/Connected.svg';
import ConnectedFocused from './assets/customer/default/ConnectedFocused.svg';
import ConnectedPremium from './assets/customer/default/ConnectedPremium.svg';
import ConnectedPremiumColor from './assets/customer/default/ConnectedPremiumColor.svg';
import ConnectedPremiumColorFocused from './assets/customer/default/ConnectedPremiumColorFocused.svg';
import ConnectedPremiumFocused from './assets/customer/default/ConnectedPremiumFocused.svg';
import Contact from './assets/customer/default/Contact.svg';
import Cookie from './assets/customer/default/Cookie.svg';
import Cross from './assets/customer/default/Cross.svg';
import Csa10 from './assets/customer/default/Csa10.svg';
import Csa12 from './assets/customer/default/Csa12.svg';
import Csa14 from './assets/customer/default/Csa14.svg';
import Csa15 from './assets/customer/default/Csa15.svg';
import Csa16 from './assets/customer/default/Csa16.svg';
import Csa18 from './assets/customer/default/Csa18.svg';
import Csa6 from './assets/customer/default/Csa6.svg';
import Csa9 from './assets/customer/default/Csa9.svg';
import CsaAL from './assets/customer/default/CsaAL.svg';
import Disconnected from './assets/customer/default/Disconnected.svg';
import DisconnectedFocused from './assets/customer/default/DisconnectedFocused.svg';
import Download from './assets/customer/default/Download.svg';
import DownloadIssue from './assets/customer/default/DownloadIssue.svg';
import DownloadPause from './assets/customer/default/DownloadPause.svg';
import DownloadToGo from './assets/customer/default/DownloadToGo.svg';
import Downloaded from './assets/customer/default/Downloaded.svg';
import Downloading from './assets/customer/default/Downloading.svg';
import Ear from './assets/customer/default/Ear.svg';
import Edit from './assets/customer/default/Edit.svg';
import EditFocused from './assets/customer/default/EditFocused.svg';
import Embed from './assets/customer/default/Embed.svg';
import Error from './assets/customer/default/Error.svg';
import ErrorEmoji from './assets/customer/default/ErrorEmoji.svg';
import Exclamation from './assets/customer/default/Exclamation.svg';
import EyeOff from './assets/customer/default/EyeOff.svg';
import EyeOn from './assets/customer/default/EyeOn.svg';
import FIFA2026 from './assets/customer/default/FIFA2026.svg';
import Facebook from './assets/customer/default/Facebook.svg';
import FacebookRectangle from './assets/customer/default/FacebookRectangle.svg';
import Fire from './assets/customer/default/Fire.svg';
import FireFocused from './assets/customer/default/FireFocused.svg';
import FontType from './assets/customer/default/FontType.svg';
import Football from './assets/customer/default/Football.svg';
import FootballFocused from './assets/customer/default/FootballFocused.svg';
import FreemiumLock from './assets/customer/default/FreemiumLock.svg';
import Friends from './assets/customer/default/Friends.svg';
import Genres from './assets/customer/default/Genres.svg';
import Gift from './assets/customer/default/Gift.svg';
import GoBack from './assets/customer/default/GoBack.svg';
import Google from './assets/customer/default/Google.svg';
import GooglePodcast from './assets/customer/default/GooglePodcast.svg';
import Guide from './assets/customer/default/Guide.svg';
import Help from './assets/customer/default/Help.svg';
import HelpFocused from './assets/customer/default/HelpFocused.svg';
import History from './assets/customer/default/History.svg';
import Home from './assets/customer/default/Home.svg';
import HomeFocused from './assets/customer/default/HomeFocused.svg';
import IdealColor from './assets/customer/default/IdealColor.svg';
import IdealDefault from './assets/customer/default/IdealDefault.svg';
import Info from './assets/customer/default/Info.svg';
import InfoFocused from './assets/customer/default/InfoFocused.svg';
import InfoLight from './assets/customer/default/InfoLight.svg';
import Instagram from './assets/customer/default/Instagram.svg';
import Itunes from './assets/customer/default/Itunes.svg';
import JustIn from './assets/customer/default/JustIn.svg';
import KebabMenu from './assets/customer/default/KebabMenu.svg';
import Kids from './assets/customer/default/Kids.svg';
import KidsAge1 from './assets/customer/default/KidsAge1.svg';
import KidsAge1Focused from './assets/customer/default/KidsAge1Focused.svg';
import KidsAge3 from './assets/customer/default/KidsAge3.svg';
import KidsAge3Focused from './assets/customer/default/KidsAge3Focused.svg';
import KidsAge4 from './assets/customer/default/KidsAge4.svg';
import KidsAge4Focused from './assets/customer/default/KidsAge4Focused.svg';
import KidsAge6 from './assets/customer/default/KidsAge6.svg';
import KidsAge6Focused from './assets/customer/default/KidsAge6Focused.svg';
import KidsAge7 from './assets/customer/default/KidsAge7.svg';
import KidsAge7Focused from './assets/customer/default/KidsAge7Focused.svg';
import KidsFamily from './assets/customer/default/KidsFamily.svg';
import KidsFamilyFocused from './assets/customer/default/KidsFamilyFocused.svg';
import KidsFocused from './assets/customer/default/KidsFocused.svg';
import KidsHome from './assets/customer/default/KidsHome.svg';
import KidsHomeFocused from './assets/customer/default/KidsHomeFocused.svg';
import KidsLeave from './assets/customer/default/KidsLeave.svg';
import KidsLeaveFocused from './assets/customer/default/KidsLeaveFocused.svg';
import KidsMovie from './assets/customer/default/KidsMovie.svg';
import KidsMovieFocused from './assets/customer/default/KidsMovieFocused.svg';
import KidsSearch from './assets/customer/default/KidsSearch.svg';
import KidsSearchFocused from './assets/customer/default/KidsSearchFocused.svg';
import KidsSeries from './assets/customer/default/KidsSeries.svg';
import KidsSeriesFocused from './assets/customer/default/KidsSeriesFocused.svg';
import Laptop from './assets/customer/default/Laptop.svg';
import Leaf1 from './assets/customer/default/Leaf1.svg';
import Leaf2 from './assets/customer/default/Leaf2.svg';
import Like from './assets/customer/default/Like.svg';
import Liked from './assets/customer/default/Liked.svg';
import Link from './assets/customer/default/Link.svg';
import ListAdd from './assets/customer/default/ListAdd.svg';
import ListAdded from './assets/customer/default/ListAdded.svg';
import ListRemoved from './assets/customer/default/ListRemoved.svg';
import Live from './assets/customer/default/Live.svg';
import LiveFocused from './assets/customer/default/LiveFocused.svg';
import Loading from './assets/customer/default/Loading.svg';
import LocalVersionTag from './assets/customer/default/LocalVersionTag.svg';
import Lock from './assets/customer/default/Lock.svg';
import Logout from './assets/customer/default/Logout.svg';
import MagicWand from './assets/customer/default/MagicWand.svg';
import MicroDramas from './assets/customer/default/MicroDramas.svg';
import Monogram from './assets/customer/default/Monogram.svg';
import Movies from './assets/customer/default/Movies.svg';
import MoviesFocused from './assets/customer/default/MoviesFocused.svg';
import Offline from './assets/customer/default/Offline.svg';
import One from './assets/customer/default/One.svg';
import OneColor from './assets/customer/default/OneColor.svg';
import OriginalVersionTag from './assets/customer/default/OriginalVersionTag.svg';
import ParentalGuidanceDiscrimination from './assets/customer/default/ParentalGuidanceDiscrimination.svg';
import ParentalGuidanceDrugs from './assets/customer/default/ParentalGuidanceDrugs.svg';
import ParentalGuidanceFoulLanguage from './assets/customer/default/ParentalGuidanceFoulLanguage.svg';
import ParentalGuidanceScary from './assets/customer/default/ParentalGuidanceScary.svg';
import ParentalGuidanceSex from './assets/customer/default/ParentalGuidanceSex.svg';
import ParentalGuidanceViolence from './assets/customer/default/ParentalGuidanceViolence.svg';
import Pause from './assets/customer/default/Pause.svg';
import Paypal from './assets/customer/default/Paypal.svg';
import Phone from './assets/customer/default/Phone.svg';
import Pinterest from './assets/customer/default/Pinterest.svg';
import Play from './assets/customer/default/Play.svg';
import Playlist from './assets/customer/default/Playlist.svg';
import PlaylistFocused from './assets/customer/default/PlaylistFocused.svg';
import Plus from './assets/customer/default/Plus.svg';
import Podcast from './assets/customer/default/Podcast.svg';
import Premium from './assets/customer/default/Premium.svg';
import PremiumColor from './assets/customer/default/PremiumColor.svg';
import PremiumColorFocused from './assets/customer/default/PremiumColorFocused.svg';
import PremiumFocused from './assets/customer/default/PremiumFocused.svg';
import PrincipalProfile from './assets/customer/default/PrincipalProfile.svg';
import Privacy from './assets/customer/default/Privacy.svg';
import ProductPlacement from './assets/customer/default/ProductPlacement.svg';
import Programs from './assets/customer/default/Programs.svg';
import Purchase from './assets/customer/default/Purchase.svg';
import QRCode from './assets/customer/default/QRCode.svg';
import RSS from './assets/customer/default/RSS.svg';
import Refresh from './assets/customer/default/Refresh.svg';
import RelatedVideos from './assets/customer/default/RelatedVideos.svg';
import RelatedVideosFocused from './assets/customer/default/RelatedVideosFocused.svg';
import Remote from './assets/customer/default/Remote.svg';
import Remove from './assets/customer/default/Remove.svg';
import Search from './assets/customer/default/Search.svg';
import SearchFocused from './assets/customer/default/SearchFocused.svg';
import SeekBackward from './assets/customer/default/SeekBackward.svg';
import SeekBackwardFeedback from './assets/customer/default/SeekBackwardFeedback.svg';
import SeekForward from './assets/customer/default/SeekForward.svg';
import SeekForwardFeedback from './assets/customer/default/SeekForwardFeedback.svg';
import Series from './assets/customer/default/Series.svg';
import SeriesFocused from './assets/customer/default/SeriesFocused.svg';
import Settings from './assets/customer/default/Settings.svg';
import SettingsEco1 from './assets/customer/default/SettingsEco1.svg';
import SettingsEco2 from './assets/customer/default/SettingsEco2.svg';
import SettingsFocused from './assets/customer/default/SettingsFocused.svg';
import Share from './assets/customer/default/Share.svg';
import ShareFocused from './assets/customer/default/ShareFocused.svg';
import Share_Android from './assets/customer/default/Share_Android.svg';
import Share_iOS from './assets/customer/default/Share_iOS.svg';
import Shield from './assets/customer/default/Shield.svg';
import SkipNext from './assets/customer/default/SkipNext.svg';
import SkipNextFocused from './assets/customer/default/SkipNextFocused.svg';
import SkipPrevious from './assets/customer/default/SkipPrevious.svg';
import SkipPreviousFocused from './assets/customer/default/SkipPreviousFocused.svg';
import Sliders from './assets/customer/default/Sliders.svg';
import Slot from './assets/customer/default/Slot.svg';
import Space from './assets/customer/default/Space.svg';
import Speed from './assets/customer/default/Speed.svg';
import SpeedFilled from './assets/customer/default/SpeedFilled.svg';
import Star from './assets/customer/default/Star.svg';
import StartOver from './assets/customer/default/StartOver.svg';
import Television from './assets/customer/default/Television.svg';
import TelevisionFocused from './assets/customer/default/TelevisionFocused.svg';
import TextIncrease from './assets/customer/default/TextIncrease.svg';
import Tiktok from './assets/customer/default/Tiktok.svg';
import Timer from './assets/customer/default/Timer.svg';
import TimerFilled from './assets/customer/default/TimerFilled.svg';
import Tracks from './assets/customer/default/Tracks.svg';
import TracksFilled from './assets/customer/default/TracksFilled.svg';
import Trailer from './assets/customer/default/Trailer.svg';
import Trash from './assets/customer/default/Trash.svg';
import Twitter from './assets/customer/default/Twitter.svg';
import UEFA from './assets/customer/default/UEFA.svg';
import UEFAFocused from './assets/customer/default/UEFAFocused.svg';
import Univers from './assets/customer/default/Univers.svg';
import Unlock from './assets/customer/default/Unlock.svg';
import Usabilla from './assets/customer/default/Usabilla.svg';
import Vocal from './assets/customer/default/Vocal.svg';
import Volume from './assets/customer/default/Volume.svg';
import Volume1 from './assets/customer/default/Volume1.svg';
import Volume2 from './assets/customer/default/Volume2.svg';
import Volume3 from './assets/customer/default/Volume3.svg';
import Volume4 from './assets/customer/default/Volume4.svg';
import VolumeDown from './assets/customer/default/VolumeDown.svg';
import VolumeFilled from './assets/customer/default/VolumeFilled.svg';
import VolumeOff from './assets/customer/default/VolumeOff.svg';
import VolumeUp from './assets/customer/default/VolumeUp.svg';
import Voting from './assets/customer/default/Voting.svg';
import Warning from './assets/customer/default/Warning.svg';
import Wave from './assets/customer/default/Wave.svg';
import Wave1 from './assets/customer/default/Wave1.svg';
import Wave2 from './assets/customer/default/Wave2.svg';
import Wave3 from './assets/customer/default/Wave3.svg';
import Wave4 from './assets/customer/default/Wave4.svg';
import WhatsApp from './assets/customer/default/WhatsApp.svg';
import Youtube from './assets/customer/default/Youtube.svg';

export default {
  Accessibility,
  ActionPlan,
  AddUser,
  Agenda,
  AgendaFocused,
  Ages,
  AirPlay,
  AirPlayOff,
  AirPlayOn,
  Alert,
  AlertOff,
  AlertOn,
  AlertUnread,
  Android,
  Apple,
  Approved,
  ArrowDown,
  ArrowLeft,
  ArrowLeftWithBase,
  ArrowRight,
  ArrowRightWithBase,
  ArrowSideNav,
  ArrowUp,
  Article,
  Audio,
  AudioDescriptionTag,
  Audiobook,
  BackSpace,
  BackToLive,
  BankCard,
  Brightness,
  Brightness1,
  Brightness2,
  Brightness3,
  Brightness4,
  BrightnessFilled,
  Buffering,
  Cancel,
  CapsLock,
  Category,
  CategoryFocused,
  Chapter,
  Check,
  CheckFocused,
  CheckLight,
  Chromecast,
  ChromecastOff,
  ChromecastOff1,
  ChromecastOff2,
  ChromecastOn,
  ChromecastOn1,
  ChromecastOn2,
  Clock,
  Connected,
  ConnectedFocused,
  ConnectedPremium,
  ConnectedPremiumColor,
  ConnectedPremiumColorFocused,
  ConnectedPremiumFocused,
  Contact,
  Cookie,
  Cross,
  Csa10,
  Csa12,
  Csa14,
  Csa15,
  Csa16,
  Csa18,
  Csa6,
  Csa9,
  CsaAL,
  Disconnected,
  DisconnectedFocused,
  Download,
  DownloadIssue,
  DownloadPause,
  DownloadToGo,
  Downloaded,
  Downloading,
  Ear,
  Edit,
  EditFocused,
  Embed,
  Error,
  ErrorEmoji,
  Exclamation,
  EyeOff,
  EyeOn,
  FIFA2026,
  Facebook,
  FacebookRectangle,
  Fire,
  FireFocused,
  FontType,
  Football,
  FootballFocused,
  FreemiumLock,
  Friends,
  Genres,
  Gift,
  GoBack,
  Google,
  GooglePodcast,
  Guide,
  Help,
  HelpFocused,
  History,
  Home,
  HomeFocused,
  IdealColor,
  IdealDefault,
  Info,
  InfoFocused,
  InfoLight,
  Instagram,
  Itunes,
  JustIn,
  KebabMenu,
  Kids,
  KidsAge1,
  KidsAge1Focused,
  KidsAge3,
  KidsAge3Focused,
  KidsAge4,
  KidsAge4Focused,
  KidsAge6,
  KidsAge6Focused,
  KidsAge7,
  KidsAge7Focused,
  KidsFamily,
  KidsFamilyFocused,
  KidsFocused,
  KidsHome,
  KidsHomeFocused,
  KidsLeave,
  KidsLeaveFocused,
  KidsMovie,
  KidsMovieFocused,
  KidsSearch,
  KidsSearchFocused,
  KidsSeries,
  KidsSeriesFocused,
  Laptop,
  Leaf1,
  Leaf2,
  Like,
  Liked,
  Link,
  ListAdd,
  ListAdded,
  ListRemoved,
  Live,
  LiveFocused,
  Loading,
  LocalVersionTag,
  Lock,
  Logout,
  MagicWand,
  MicroDramas,
  Monogram,
  Movies,
  MoviesFocused,
  Offline,
  One,
  OneColor,
  OriginalVersionTag,
  ParentalGuidanceDiscrimination,
  ParentalGuidanceDrugs,
  ParentalGuidanceFoulLanguage,
  ParentalGuidanceScary,
  ParentalGuidanceSex,
  ParentalGuidanceViolence,
  Pause,
  Paypal,
  Phone,
  Pinterest,
  Play,
  Playlist,
  PlaylistFocused,
  Plus,
  Podcast,
  Premium,
  PremiumColor,
  PremiumColorFocused,
  PremiumFocused,
  PrincipalProfile,
  Privacy,
  ProductPlacement,
  Programs,
  Purchase,
  QRCode,
  RSS,
  Refresh,
  RelatedVideos,
  RelatedVideosFocused,
  Remote,
  Remove,
  Search,
  SearchFocused,
  SeekBackward,
  SeekBackwardFeedback,
  SeekForward,
  SeekForwardFeedback,
  Series,
  SeriesFocused,
  Settings,
  SettingsEco1,
  SettingsEco2,
  SettingsFocused,
  Share,
  ShareFocused,
  Share_Android,
  Share_iOS,
  Shield,
  SkipNext,
  SkipNextFocused,
  SkipPrevious,
  SkipPreviousFocused,
  Sliders,
  Slot,
  Space,
  Speed,
  SpeedFilled,
  Star,
  StartOver,
  Television,
  TelevisionFocused,
  TextIncrease,
  Tiktok,
  Timer,
  TimerFilled,
  Tracks,
  TracksFilled,
  Trailer,
  Trash,
  Twitter,
  UEFA,
  UEFAFocused,
  Univers,
  Unlock,
  Usabilla,
  Vocal,
  Volume,
  Volume1,
  Volume2,
  Volume3,
  Volume4,
  VolumeDown,
  VolumeFilled,
  VolumeOff,
  VolumeUp,
  Voting,
  Warning,
  Wave,
  Wave1,
  Wave2,
  Wave3,
  Wave4,
  WhatsApp,
  Youtube,
};
